import React from 'react';
import '../../styles/components/alert.css';

const Alert = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  footer = "", 
  type = "success" // success or fail
}) => {
  if (!isOpen) return null;

  return (
    <div className={`custom-alert ${type}`} style={{ display: 'block' }}>
      <div className="custom-alert-content">
        <div className="custom-alert-header">
          <span id="customAlertHeader">{title}</span>
          <button className="custom-alert-close" onClick={onClose}>&times;</button>
        </div>
        <div className="custom-alert-body">
          <p>{message}</p>
        </div>
        {footer && <div className="custom-alert-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Alert;